const UNITS: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
  { unit: 'year', seconds: 365 * 24 * 60 * 60 },
  { unit: 'month', seconds: 30 * 24 * 60 * 60 },
  { unit: 'week', seconds: 7 * 24 * 60 * 60 },
  { unit: 'day', seconds: 24 * 60 * 60 },
  { unit: 'hour', seconds: 60 * 60 },
  { unit: 'minute', seconds: 60 },
]

const formatter = new Intl.RelativeTimeFormat('nb', { numeric: 'auto' })

/**
 * Norwegian relative timestamp for the sidebar ("for 5 minutter siden",
 * "i går"). Sub-minute differences — including future dates from clock
 * skew — collapse to "nå".
 */
export function formatRelativeTime(date: Date | null, now: Date = new Date()): string {
  if (date === null) return ''
  const diffSeconds = Math.floor((date.getTime() - now.getTime()) / 1000)
  if (diffSeconds > -60) return 'nå'
  for (const { unit, seconds } of UNITS) {
    if (-diffSeconds >= seconds) {
      return formatter.format(Math.ceil(diffSeconds / seconds), unit)
    }
  }
  return 'nå'
}
